import { all, call, put, takeEvery } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess } from "./actions";
import { userLogin, parentLogin, getAllMasterData } from "../../../helpers/backend_helper"
import { mapToOptions } from "utils/optionMapper";


function* loginUser({ payload: { user } }) {
  try {
    var data = JSON.stringify(user);
    let response;

    if (window.location.pathname === "/login") {
      response = yield parentLogin(data);
    } else if (window.location.pathname === "/admin") {
      response = yield userLogin(data);
    }

    // console.log(response);

    if (response.data.success) {
      // console.log("Login Success: ", response.data);
      if (window.location.pathname === "/login") {
        localStorage.setItem("authUser", JSON.stringify(response.data.parent))
        localStorage.setItem("token", response.data.token)
        localStorage.setItem("primary_mail_id", JSON.stringify(response.data.parent.primary_mail_id))
        localStorage.setItem("userRole", "parent");
        localStorage.setItem("authUserId", response.data.parent.parent_id)
        yield put(loginSuccess(response));

        // 🧩 parent login success → fetch master data and cache
        try {
          const [master] = yield all([
            call(getAllMasterData),
          ]);
          const mastersData = master?.data?.data || {};

          const mappedData = {
            academics: mapToOptions(mastersData.academics, "id", "academicYear"),
            clusters: mapToOptions(mastersData.clusters, "cluster_id", "cluster_name"),
            programs: mapToOptions(mastersData.programs, "program_id", "program_name"),
            centers: mapToOptions(mastersData.centers, "center_id", "center_name"),
            categories: mapToOptions(mastersData.categories, "category_id", "category_name"),
            payments: mapToOptions(mastersData.payments, "id", "payment_name"),
            roles: mapToOptions(mastersData.roles, "role_id", "roleName"),
            ageGroups: mapToOptions(mastersData.ageGroups, "id", "label"),
            currentAcademic: mastersData.academics?.find((ay) => ay.currentAY === 1) || null,
          };

          localStorage.setItem('masterDataCache', JSON.stringify({ data: mappedData }));
        } catch (err) {
          console.warn("Failed to prefetch master data on parent login:", err);
        }

        window.location.href = `/student-selection`;
      } else if (window.location.pathname === "/admin") {
        localStorage.setItem("authUser", JSON.stringify(response.data.user))
        localStorage.setItem("email", JSON.stringify(response.data.user.email))
        localStorage.setItem("token", response.data.token)
        localStorage.setItem("role", response.data.user.role_id)
        localStorage.setItem("authUserId", response.data.user.user_id)
        localStorage.setItem("userRole", response.data.user.role_name);
        yield put(loginSuccess(response));

        // 🧩 login success → fetch master data and navigate simultaneously
        const [master] = yield all([
          call(getAllMasterData),
        ]);

        const mastersData = master?.data?.data || {};

        const mappedData = {
          academics: mapToOptions(mastersData.academics, "id", "academicYear"),
          clusters: mapToOptions(
            mastersData.clusters,
            "cluster_id",
            "cluster_name"
          ),
          programs: mapToOptions(
            mastersData.programs,
            "program_id",
            "program_name"
          ),
          centers: mapToOptions(
            mastersData.centers,
            "center_id",
            "center_name"
          ),
          categories: mapToOptions(
            mastersData.categories,
            "category_id",
            "category_name"
          ),
          payments: mapToOptions(mastersData.payments, "id", "payment_name"),
          roles: mapToOptions(mastersData.roles, "role_id", "roleName"),
          ageGroups: mapToOptions(mastersData.ageGroups, "id", "label"),
          currentAcademic:
            mastersData.academics?.find((ay) => ay.currentAY === 1) || null,
        };

        //  Save to state + cache only when API data is ready
        localStorage.setItem('masterDataCache', JSON.stringify({ data: mappedData }));

        window.location.href = `/dashboard`;
      }
    } else {
      yield put(apiError(response?.data?.error || "Login failed"));
    }
  } catch (error) {
    let errorMessage = "Something went wrong. Please try again.";

    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    yield put(apiError(errorMessage));
  }
}

function* logoutUser({ payload: { history } }) {

  try {
    const user = localStorage.getItem('email');

    localStorage.removeItem("authUser");
    localStorage.removeItem('authUserId');
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("userRole");
    localStorage.removeItem("primary_mail_id");
    localStorage.removeItem("masterDataCache");
    localStorage.removeItem("profileImage");

    // pass the log details
    const data = {
      action: 'Logout',
      user,
    };
    history('/login');

  } catch (error) {
    // yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
